@if (isMobile()) {
  <header class="mobile-header">
    <ng-container *ngTemplateOutlet="brand" />
    <button #hamburger class="icon-button hamburger-button" type="button" aria-label="Abrir menú" aria-controls="dashboard-menu-dialog" aria-haspopup="dialog" [attr.aria-expanded]="isOpen()" [disabled]="overlayActive()" (click)="open()">
      <span class="icon hamburger" aria-hidden="true"></span>
    </button>
  </header>
  <dialog #dialog class="mobile-dialog" id="dashboard-menu-dialog" aria-label="Menú principal" (cancel)="onCancel($event)" (close)="onDialogClosed()">
    <button class="backdrop" type="button" tabindex="-1" aria-label="Cerrar menú" (click)="close()"></button>
    <section class="mobile-panel" tabindex="-1" (keydown)="onKeydown($event)">
      <header class="menu-header">
        <ng-container *ngTemplateOutlet="brand" />
        <button #closeButton class="icon-button close-button" type="button" aria-label="Cerrar menú" (click)="close()">
          <span class="icon close" aria-hidden="true"></span>
        </button>
      </header>
      <ng-container *ngTemplateOutlet="navigation" />
    </section>
  </dialog>
} @else {
  <aside #desktopMenu class="desktop-menu" aria-label="Menú principal">
    <header class="menu-header">
      <ng-container *ngTemplateOutlet="brand" />
    </header>
    <ng-container *ngTemplateOutlet="navigation" />
  </aside>
}

<ng-template #brand>
  <div class="brand">
    <div class="logo">
      <span class="portal-name">Portal Desarrolladores</span>
      <span class="product-name">Mundo Hogar</span>
    </div>
    <div class="profile">Acceso administrador</div>
  </div>
</ng-template>

<ng-template #navigation>
  <nav class="menu-items" aria-label="Secciones del portal">
    @for (route of dashboardRoutes; track route.path) {
      <a class="item-container" routerLinkActive="active" ariaCurrentWhenActive="page" [routerLinkActiveOptions]="activeMatchOptions" [routerLink]="route.path" (click)="close()">
        <span class="icon {{ route.icon }}" aria-hidden="true"></span>
        <span class="label">{{ route.label }}</span>
      </a>
    }
  </nav>
  @if (user(); as currentUser) {
    <footer class="user-info-container">
      <div class="avatar" aria-hidden="true">{{ currentUser.initials }}</div>
      <div class="user-info-content">
        <div class="greeting">Hola 👋🏻</div>
        <div class="name" [title]="currentUser.name">{{ currentUser.name }}</div>
      </div>
      <button class="icon-button logout-button" type="button" aria-label="Cerrar sesión" (click)="signOut()">
        <span class="icon logout" aria-hidden="true"></span>
      </button>
    </footer>
  }
</ng-template>
